import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import PaymentHistroyOverlay from "./component/PaymentHistroyOverlay";

const PaymentHistory = () => {
  const [checked, setChecked] = useState([true, false]);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleChange1 = (event) => {
    setChecked([event.target.checked, event.target.checked]);
  };
  const [overlay, setOverlay] = useState(true);

  const handleChange2 = (event) => {
    setChecked([event.target.checked, checked[1]]);
  };

  const handleChange3 = (event) => {
    setChecked([checked[0], event.target.checked]);
  };
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const children = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFF",
      }}
      className="px-3"
    >
      <div className="row position-relative">
        <div className="m-0 p-0 d-flex align-items-center col-3">
          <FormControlLabel
            //   sx={{ border: "2px solid red" }}
            control={<Checkbox checked={checked[0]} onChange={handleChange2} />}
            className="p-0 m-0"
          />
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Voucher No: <span className="fs-14px fw-500">1654321</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center col-3">
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Voucher Date: <span className="fs-14px fw-500">1654321</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center col-3">
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Voucher Amount:{" "}
            <span className="fs-14px fw-500">2,000,000,000.00</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center justify-content-end col-3">
          <div
            className="fs-12px d-flex align-items-center text-link gap-1 p-0 m-0 pe-1"
            style={{ textDecoration: "underline" }}
          >
            View Invoice
          </div>
        </div>

        <div className="m-0 p-0 px-4">
          <div className="m-0 p-0  px-2 d-flex flex-column gap-1">
            <div className="row bg-success-20">
              <div className="col-6 d-flex align-items-center">
                <Checkbox {...label} defaultChecked />
                <div className="m-0 p-0 d-flex flex-column">
                  <span className="fw-500 fs-14px">
                    Uttarakhand Purv Sainik Kalyan Nigam ltd.
                  </span>
                  <span className=" text-black-60 fs-12px d-flex gap-2 align-items-center">
                    <span>Invoice No: 6546654</span>
                    <span>Invoice Date: 21/4/2253</span>
                    <span className="fw-600 text-success-100">
                      FULL PAYMENT
                    </span>
                  </span>
                </div>
                     <div className="m-0 p-0 d-flex flex-column ms-3">
                    <span className="fs-14px fw-500 text-en">Transaction Date</span>
                    <span className="fs-14px fw-500 text-en">25-22-2025</span>
                </div>
              </div>
              <div className="col-6 m-0 p-0">
                <div className="row m-0 p-0 ">
                  <div className="col-2 m-0 p-0 d-flex flex-column justify-content-center">
                    <span className="fs-12px">Sanction</span>
                    <span className="fs-14px fw-500">20,000.00</span>
                  </div>
                  <div className="col-2 m-0 p-0 d-flex flex-column justify-content-center">
                    <span className="fs-12px">Invoice</span>
                    <span className="fs-14px fw-500">20,000.00</span>
                  </div>
                  <div className="col-3 m-0 p-0 d-flex flex-column justify-content-center">
                    <span className="fs-12px">Payment Amount</span>
                    <span className="fs-14px fw-500">20,000.00</span>
                  </div>
                  <div className="col-5 m-0 p-0 d-flex align-items-center">
                    <div className="d-flex justify-content-between align-items-center ">
                      <div className="d-flex align-items-center gap-2">
                        <span
                          className={`rounded-2 bg-success-20 d-flex align-items-center px-2 gap-1`}
                        >
                          <span className="fs-12px text-black-60">L2</span>
                          <span>
                            <i
                              className="icon-verified text-success-100"
                              style={{ height: "14px", width: "14px" }}
                            ></i>
                            
                          </span>
                        </span>

                        <span
                          className={` ${"bg-danger-20"} rounded-2 d-flex align-items-center px-2 gap-1`}
                        >
                          <span className="fs-12px text-black-60">L3</span>
                          <span>
                            <i
                              className="icon-warning text-warning-success-100"
                              style={{ height: "14px", width: "14px" }}
                            ></i>
                          </span>
                        </span>

                        <span>
                          <div className="d-flex gap-3 align-items-center">
                            <i
                              className="icon-remove_red_eye text-info-100 cursor-pointer"
                              onClick={() => setOverlay(false)}
                            ></i>
                            <i className="icon-payments text-danger-100"></i>
                            <i className="icon-monetization_on_rupees"></i>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row bg-success-20">
              <div className="col-6 d-flex align-items-center">

                <Checkbox {...label} defaultChecked />
                <div className="m-0 p-0 d-flex flex-column">
                  <span className="fw-500 fs-14px">
                    Uttarakhand Purv Sainik Kalyan Nigam ltd.
                  </span>
                  <span className=" text-black-60 fs-12px d-flex gap-2 align-items-center">
                    <span>Invoice No: 6546654</span>
                    <span>Invoice Date: 21/4/2253</span>
                    <span className="fw-600 text-warning-100">
                      PARTIAL PAYMENT
                    </span>
                  </span>
                </div>

                <div className="m-0 p-0 d-flex flex-column ms-3">
                    <span className="fs-14px fw-500">Transaction Date</span>
                    <span className="fs-14px fw-500">25-22-2025</span>
                </div>
              </div>

              <div className="col-6 m-0 p-0">
                <div className="row m-0 p-0 ">
                  <div className="col-2 m-0 p-0 d-flex flex-column justify-content-center">
                    <span className="fs-12px">Sanction</span>
                    <span className="fs-14px fw-500">20,000.00</span>
                  </div>
                  <div className="col-2 m-0 p-0 d-flex flex-column justify-content-center">
                    <span className="fs-12px">Invoice</span>
                    <span className="fs-14px fw-500">20,000.00</span>
                  </div>
                  <div className="col-3 m-0 p-0 d-flex flex-column justify-content-center">
                    <span className="fs-12px">Payment Amount</span>
                    <span className="fs-14px fw-500">20,000.00</span>
                  </div>
                  <div className="col-5 m-0 p-0 d-flex align-items-center">
                    <div className="d-flex justify-content-between align-items-center ">
                      <div className="d-flex align-items-center gap-2">
                        <span
                          className={`rounded-2 bg-success-20 d-flex align-items-center px-2 gap-1`}
                        >
                          <span className="fs-12px text-black-60">L2</span>
                          <span>
                            <i
                              className="icon-verified text-success-100"
                              style={{ height: "14px", width: "14px" }}
                            ></i>
                          </span>
                        </span>

                        <span
                          className={` ${"bg-danger-20"} rounded-2 d-flex align-items-center px-2 gap-1`}
                        >
                          <span className="fs-12px text-black-60">L3</span>
                          <span>
                            <i
                              className="icon-warning text-warning-success-100"
                              style={{ height: "14px", width: "14px" }}
                            ></i>
                          </span>
                        </span>

                        <span>
                          <div className="d-flex gap-3 align-items-center">
                            <i
                              className="icon-remove_red_eye text-info-100"
                              // onClick={() => {setOverlay(false); setHiteye(false)}}
                            ></i>
                            <i className="icon-payments text-danger-100"></i>
                            <i className="icon-monetization_on_rupees"></i>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="m-0 p-0 d-flex align-items-center col-3">
          <FormControlLabel
            //   sx={{ border: "2px solid red" }}
            control={<Checkbox checked={checked[1]} onChange={handleChange3} />}
            className="p-0 m-0"
          />
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Voucher No: <span className="fs-14px fw-500">1654321</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center col-3">
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Voucher Date: <span className="fs-14px fw-500">1654321</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center col-3">
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Voucher Amount:{" "}
            <span className="fs-14px fw-500">2,000,000,000.00</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center justify-content-end col-3">
          <div
            className="fs-12px d-flex align-items-center text-link gap-1 p-0 m-0 pe-1"
            style={{ textDecoration: "underline" }}
          >
            View Invoice
          </div>
        </div>
      </div>
    </div>
  );
  const children2 = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFF",
      }}
      className="px-3"
    >
      <div className="row position-relative">
        <div className="m-0 p-0 d-flex align-items-center col-3">
          <FormControlLabel
            //   sx={{ border: "2px solid red" }}
            control={<Checkbox checked={checked[0]} onChange={handleChange2} />}
            className="p-0 m-0"
          />
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Voucher No: <span className="fs-14px fw-500">1654321</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center col-3">
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Voucher Date: <span className="fs-14px fw-500">1654321</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center col-3">
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Voucher Amount:{" "}
            <span className="fs-14px fw-500">2,000,000,000.00</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center justify-content-end col-3">
          <div
            className="fs-12px d-flex align-items-center text-link gap-1 p-0 m-0 pe-1"
            style={{ textDecoration: "underline" }}
          >
            View Invoice
          </div>
        </div>

        <div className="m-0 p-0 px-4">
          <div className="m-0 p-0  px-2 d-flex flex-column gap-1">
            <div className="row bg-success-20">
              <div className="col-6 d-flex align-items-center">
                <Checkbox {...label} defaultChecked />
                <div className="m-0 p-0 d-flex flex-column">
                  <span className="fw-500 fs-14px">
                    Uttarakhand Purv Sainik Kalyan Nigam ltd.
                  </span>
                  <span className=" text-black-60 fs-12px d-flex gap-2 align-items-center">
                    <span>Invoice No: 6546654</span>
                    <span>Invoice Date: 21/4/2253</span>
                    <span className="fw-600 text-success-100">
                      FULL PAYMENT
                    </span>
                  </span>
                </div>
              </div>
              <div className="col-6 m-0 p-0">
                <div className="row m-0 p-0 ">
                  <div className="col-2 m-0 p-0 d-flex flex-column justify-content-center">
                    <span className="fs-12px">Sanction</span>
                    <span className="fs-14px fw-500">20,000.00</span>
                  </div>
                  <div className="col-2 m-0 p-0 d-flex flex-column justify-content-center">
                    <span className="fs-12px">Invoice</span>
                    <span className="fs-14px fw-500">20,000.00</span>
                  </div>
                  <div className="col-3 m-0 p-0 d-flex flex-column justify-content-center">
                    <span className="fs-12px">Payment Amount</span>
                    <span className="fs-14px fw-500">20,000.00</span>
                  </div>
                  <div className="col-5 m-0 p-0 d-flex align-items-center">
                    <div className="d-flex justify-content-between align-items-center ">
                      <div className="d-flex align-items-center gap-2">
                        <span
                          className={`rounded-2 bg-success-20 d-flex align-items-center px-2 gap-1`}
                        >
                          <span className="fs-12px text-black-60">L2</span>
                          <span>
                            <i
                              className="icon-verified text-success-100"
                              style={{ height: "14px", width: "14px" }}
                            ></i>
                          </span>
                        </span>

                        <span
                          className={` ${"bg-danger-20"} rounded-2 d-flex align-items-center px-2 gap-1`}
                        >
                          <span className="fs-12px text-black-60">L3</span>
                          <span>
                            <i
                              className="icon-warning text-warning-success-100"
                              style={{ height: "14px", width: "14px" }}
                            ></i>
                          </span>
                        </span>

                        <span>
                          <div className="d-flex gap-3 align-items-center">
                            <i
                              className="icon-remove_red_eye text-info-100"
                              // onClick={() => {setOverlay(false); setHiteye(false)}}
                            ></i>
                            <i className="icon-monetization_on_rupees"></i>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row bg-success-20">
              <div className="col-6 d-flex align-items-center">
                <Checkbox {...label} defaultChecked />
                <div className="m-0 p-0 d-flex flex-column">
                  <span className="fw-500 fs-14px">
                    Uttarakhand Purv Sainik Kalyan Nigam ltd.
                  </span>
                  <span className=" text-black-60 fs-12px d-flex gap-2 align-items-center">
                    <span>Invoice No: 6546654</span>
                    <span>Invoice Date: 21/4/2253</span>
                    <span className="fw-600 text-warning-100">
                      PARTIAL PAYMENT
                    </span>
                  </span>
                </div>
              </div>
              <div className="col-6 m-0 p-0">
                <div className="row m-0 p-0 ">
                  <div className="col-2 m-0 p-0 d-flex flex-column justify-content-center">
                    <span className="fs-12px">Sanction</span>
                    <span className="fs-14px fw-500">20,000.00</span>
                  </div>
                  <div className="col-2 m-0 p-0 d-flex flex-column justify-content-center">
                    <span className="fs-12px">Invoice</span>
                    <span className="fs-14px fw-500">20,000.00</span>
                  </div>
                  <div className="col-3 m-0 p-0 d-flex flex-column justify-content-center">
                    <span className="fs-12px">Payment Amount</span>
                    <span className="fs-14px fw-500">20,000.00</span>
                  </div>
                  <div className="col-5 m-0 p-0 d-flex align-items-center">
                    <div className="d-flex justify-content-between align-items-center ">
                      <div className="d-flex align-items-center gap-2">
                        <span
                          className={`rounded-2 bg-success-20 d-flex align-items-center px-2 gap-1`}
                        >
                          <span className="fs-12px text-black-60">L2</span>
                          <span>
                            <i
                              className="icon-verified text-success-100"
                              style={{ height: "14px", width: "14px" }}
                            ></i>
                          </span>
                        </span>

                        <span
                          className={` ${"bg-danger-20"} rounded-2 d-flex align-items-center px-2 gap-1`}
                        >
                          <span className="fs-12px text-black-60">L3</span>
                          <span>
                            <i
                              className="icon-warning text-warning-success-100"
                              style={{ height: "14px", width: "14px" }}
                            ></i>
                          </span>
                        </span>

                        <span>
                          <div className="d-flex gap-3 align-items-center">
                            <i
                              className="icon-remove_red_eye text-info-100"
                              // onClick={() => {setOverlay(false); setHiteye(false)}}
                            ></i>
                            <i className="icon-monetization_on_rupees"></i>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="m-0 p-0 d-flex align-items-center col-3">
          <FormControlLabel
            //   sx={{ border: "2px solid red" }}
            control={<Checkbox checked={checked[1]} onChange={handleChange3} />}
            className="p-0 m-0"
          />
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Voucher No: <span className="fs-14px fw-500">1654321</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center col-3">
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Voucher Date: <span className="fs-14px fw-500">1654321</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center col-3">
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Voucher Amount:{" "}
            <span className="fs-14px fw-500">2,000,000,000.00</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center justify-content-end col-3">
          <div
            className="fs-12px d-flex align-items-center text-link gap-1 p-0 m-0 pe-1"
            style={{ textDecoration: "underline" }}
          >
            View Invoice
          </div>
        </div>
      </div>
    </div>
  );
  const children3Child = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFF",
      }}
      className="px-3"
    >
      <div className="row position-relative">
        <div className="m-0 p-0 d-flex align-items-center col-3">
          <FormControlLabel
            //   sx={{ border: "2px solid red" }}
            control={<Checkbox checked={checked[0]} onChange={handleChange2} />}
            className="p-0 m-0"
          />
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Voucher No: <span className="fs-14px fw-500">1654321</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center col-3">
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Voucher Date: <span className="fs-14px fw-500">1654321</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center col-3">
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Voucher Amount:{" "}
            <span className="fs-14px fw-500">2,000,000,000.00</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center justify-content-end col-3">
          <div
            className="fs-12px d-flex align-items-center text-link gap-1 p-0 m-0 pe-1"
            style={{ textDecoration: "underline" }}
          >
            View Invoice
          </div>
        </div>

        <div className="m-0 p-0 px-4">
          <div className="m-0 p-0  px-2 d-flex flex-column gap-1">
            <div className="row bg-success-20">
              <div className="col-6 d-flex align-items-center">
                <Checkbox {...label} defaultChecked />
                <div className="m-0 p-0 d-flex flex-column">
                  <span className=" text-black-60 fs-12px d-flex gap-2 align-items-center">

                    <span className="fs-12px text-black-60 d-flex flex-column">
                    Invoice No:
                     <span className="fs-14px fw-500 text-black">
                      6546654
                     </span>
                     </span>
                    <span className="fs-12px text-black-60 d-flex flex-column">
                    Invoice Date:
                     <span className="fs-14px fw-500 text-black">
                      6546654
                     </span>
                     </span>
                    <span className="fs-12px text-black-60 d-flex flex-column">
                    Payment Amount:
                     <span className="fs-14px fw-500 text-black">
                      6546654
                     </span>
                     </span>
               
                    <span className="fw-600 text-success-100">
                      FULL PAYMENT
                    </span>
                  </span>
                </div>
              </div>
              <div className="col-6 m-0 p-0">
                <div className="row m-0 p-0 ">
                  <div className="col-2 m-0 p-0 d-flex flex-column justify-content-center">
                    <span className="fs-12px">Sanction</span>
                    <span className="fs-14px fw-500">20,000.00</span>
                  </div>
                  <div className="col-2 m-0 p-0 d-flex flex-column justify-content-center">
                    <span className="fs-12px">Invoice</span>
                    <span className="fs-14px fw-500">20,000.00</span>
                  </div>
                  <div className="col-3 m-0 p-0 d-flex flex-column justify-content-center">
                    <span className="fs-12px">Payment Amount</span>
                    <span className="fs-14px fw-500">20,000.00</span>
                  </div>
                  <div className="col-5 m-0 p-0 d-flex align-items-center">
                    <div className="d-flex justify-content-between align-items-center ">
                      <div className="d-flex align-items-center gap-2">
                        <span
                          className={`rounded-2 bg-success-20 d-flex align-items-center px-2 gap-1`}
                        >
                          <span className="fs-12px text-black-60">L2</span>
                          <span>
                            <i
                              className="icon-verified text-success-100"
                              style={{ height: "14px", width: "14px" }}
                            ></i>
                          </span>
                        </span>

                        <span
                          className={` ${"bg-danger-20"} rounded-2 d-flex align-items-center px-2 gap-1`}
                        >
                          <span className="fs-12px text-black-60">L3</span>
                          <span>
                            <i
                              className="icon-warning text-warning-success-100"
                              style={{ height: "14px", width: "14px" }}
                            ></i>
                          </span>
                        </span>

                        <span>
                          <div className="d-flex gap-3 align-items-center">
                            <i
                              className="icon-remove_red_eye text-info-100"
                              // onClick={() => {setOverlay(false); setHiteye(false)}}
                            ></i>
                            <i className="icon-monetization_on_rupees"></i>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="row">
        <div className="m-0 p-0 d-flex align-items-center col-3">
          <FormControlLabel
            //   sx={{ border: "2px solid red" }}
            control={<Checkbox checked={checked[1]} onChange={handleChange3} />}
            className="p-0 m-0"
          />
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Voucher No: <span className="fs-14px fw-500">1654321</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center col-3">
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Voucher Date: <span className="fs-14px fw-500">1654321</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center col-3">
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Voucher Amount:{" "}
            <span className="fs-14px fw-500">2,000,000,000.00</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center justify-content-end col-3">
          <div
            className="fs-12px d-flex align-items-center text-link gap-1 p-0 m-0 pe-1"
            style={{ textDecoration: "underline" }}
          >
            View Invoice
          </div>
        </div>
      </div>
    </div>
  );

  const [cardAccordion, setCardAccordion] = useState(false);

  const children3 = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFF",
      }}
      className="px-3"
    >
      <div className="row">
        <div className="m-0 p-0 d-flex align-items-center col-3">
          <FormControlLabel
            //   sx={{ border: "2px solid red" }}
            control={<Checkbox checked={checked[1]} onChange={handleChange3} />}
            className="p-0 m-0"
          />
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Sanction No: <span className="fs-14px fw-500">1654321</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center col-3">
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Sanction Date: <span className="fs-14px fw-500">1654321</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center col-3">
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Sanction Amount:{" "}
            <span className="fs-14px fw-500">2,000,000,000.00</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center justify-content-end col-3">
          <div className="fs-12px d-flex align-items-center text-link gap-1 p-0 m-0 pe-1">
            {cardAccordion ? (
              <i
                className="icon-remove_circle fs-16px text-primary-50 cursor-pointer"
                onClick={() => setCardAccordion(false)}
              ></i>
            ) : (
              <i
                className="icon-add_circle fs-16px text-primary-50 cursor-pointer"
                onClick={() => setCardAccordion(true)}
              ></i>
            )}
          </div>
        </div>
        {cardAccordion && <div className="row m-0 p-0 px-2">{children3Child}</div>}
      </div>

      {/* ==========================subdata======================== */}
    </div>
  );

  return (
    <div className="p-3">
      <div className="m-0 p-0 mb-3 d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-2">
          <div>
            <span
              className="fs-12px bg-white p-1 px-2 rounded-4"
              style={{ border: "1px solid #414041" }}
            >
              {" "}
              Sanction <i className="icon-swap_vert"></i>
            </span>
          </div>
          <div>
            <span
              className="fs-12px bg-white p-1 px-2 rounded-4"
              style={{ border: "1px solid #414041" }}
            >
              {" "}
              Departmnet Name <i className="icon-close_circle_stroke"></i>
            </span>
          </div>
        </div>
      </div>

      <div className="border-prime-100 border-1 overflow-hidden rounded-3">
        <FormControlLabel
          // label="Parent"
          sx={{ backgroundColor: "#DFF0FF", width: "100%", left: "1%" }}
          className="position-relative"
          control={
            <>
              <Checkbox
                checked={checked[0] && checked[1]}
                indeterminate={checked[0] !== checked[1]}
                onChange={handleChange1}
              />
              <div className="d-flex justify-content-between align-items-center w-100 px-1 pe-2">
                <div className="d-flex gap-3 align-items-center">
                  <div className="fs-12px d-flex align-items-center gap-1">
                    Sanction No: <span className="fs-14px fw-500">1654321</span>
                  </div>
                  <div className="fs-12px d-flex align-items-center gap-1">
                    Sanction Date:{" "}
                    <span className="fs-14px fw-500">25/12/5243</span>
                  </div>
                </div>

                <div className="fs-12px d-flex align-items-center gap-1">
                  Total Amount: <span className="fs-14px fw-500">255612</span>
                </div>
              </div>
            </>
          }
        />
        {children}
      </div>

      {/* ===============================second card============================ */}

      <div className="border-prime-100 border-1 overflow-hidden rounded-3 mt-3">
        <FormControlLabel
          // label="Parent"
          sx={{ backgroundColor: "#28326F", width: "100%", left: "1%" }}
          className="position-relative text-white"
          control={
            <>
              <Checkbox
                checked={checked[0] && checked[1]}
                indeterminate={checked[0] !== checked[1]}
                onChange={handleChange1}
              />
              <div className="d-flex justify-content-between align-items-center w-100 px-1 pe-2">
                <div className="d-flex gap-3 align-items-center">
                  <div className="fs-12px d-flex align-items-center gap-1">
                    Sanction No: <span className="fs-14px fw-500">1654321</span>
                  </div>
                  <div className="fs-12px d-flex align-items-center gap-1">
                    Sanction Date:{" "}
                    <span className="fs-14px fw-500">25/12/5243</span>
                  </div>
                </div>

                <div className="fs-12px d-flex align-items-center gap-1">
                  Total Amount: <span className="fs-14px fw-500">255612</span>
                </div>
              </div>
            </>
          }
        />
        {children2}
      </div>
      {/* ===============================third card============================ */}

      <div className="border-prime-100 border-1 overflow-hidden rounded-3 mt-3">
        <FormControlLabel
          // label="Parent"
          sx={{ backgroundColor: "#2490EA", width: "100%", left: "1%" }}
          className="position-relative text-white"
          control={
            <>
              <Checkbox
                checked={checked[0] && checked[1]}
                indeterminate={checked[0] !== checked[1]}
                onChange={handleChange1}
              />
              <div className="d-flex justify-content-between align-items-center w-100 px-1 pe-2">
                <div className="d-flex gap-3 align-items-center">
                  <div className="fs-16px d-flex align-items-center gap-1 fw-600">
                    A Uttarakhand Purv Sainik Kalyan Nigam ltd.
                  </div>
                </div>
                <div className="d-flex  gap-2">
                  <div className="fs-12px d-flex align-items-center gap-1">
                    sensation: <span className="fs-14px fw-500">255612</span>
                  </div>
                  <div className="fs-12px d-flex align-items-center gap-1">
                    Invoice Amount:{" "}
                    <span className="fs-14px fw-500">255612</span>
                  </div>
                  <div className="fs-12px d-flex align-items-center gap-1">
                    Payment: <span className="fs-14px fw-500">255612</span>
                  </div>
                </div>
              </div>
            </>
          }
        />
        {children3}
      </div>


      <div
        onClick={handleOpen}
        className="p-3 rounded-circle bg-secondary-100-hover"
        style={{
          height: "60px",
          width: "60px",
          position: "fixed",
          bottom: "20px",
          right: "20px",
          cursor: "pointer",
          display: "grid",
          placeItems: "center",
          boxShadow: "0 4px 25px #00000040",
          zIndex: "1",
        }}
      >
        {!open ? (
          <i className="icon-filter_alt text-white"></i>
        ) : (
          <i className="icon-close_circle_fill text-white"></i>
        )}
      </div>

      {/* ===========================overlay========================= */}

      <PaymentHistroyOverlay
        overlay={overlay}
        setOverlay={setOverlay}
      ></PaymentHistroyOverlay>
    </div>
  );
};
export default PaymentHistory;
